import React from 'react';
import { Link } from 'react-router-dom';
import "../introduction.css";

const skillsHighlights = (props) => {
    return (
        /*<div id='me_skills'>
            <div className='container' style={{display: "flex", flexWrap: "wrap"}}>
                <div className='center' style={{flexWrap: "wrap"}}>
                </div>
            </div>
            <div className='poster'>
                Skills
                <div className='poster_hr'/>
                <div className='poster_subheading'>
                    Skills that I bring to the table and what distinguishes me.
                </div>
            </div>
        </div>*/
        <div id='me_skills'>
            <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                <div className='poster'>
                    Skills
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        Skills that I bring to the table and what distinguishes me.
                    </div>
                    <div className='view_more_link'>
                        <Link className='more_link' to='skills'>View My Skills in Detail</Link>
                    </div>
                </div>
            </div>
            <div className='poster_right center flex_column'>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Distributed Systems
                    </div>
                    <div className='prj_description'>
                        View the technologies related to distributed systems I have experiece in.
                    </div>
                </div>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Cloud Computing
                    </div>
                    <div className='prj_description'>
                        View the technologies related to cloud computing I have experiece in.
                    </div>
                </div>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Full Stack Development
                    </div>
                    <div className='prj_description'>
                        View the technologies related to fullstack development I have experiece in.
                    </div>
                </div>
            </div>
            <div className='poster_right center flex_column' style={{paddingRight: "10vh"}}>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Research & Development
                    </div>
                </div>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Leadership
                    </div>
                </div>
                <div className='skill_high center flex_column'>
                    <div className='prj_title'>
                        Collaboration
                    </div>
                </div>
            </div>
        </div>
    )
}

export default skillsHighlights;